/**
 * Lumaro — terms-consent gate for the cart.
 *
 * Blocks checkout until the shopper ticks the AGB / privacy checkbox.
 *
 * Two constraints shape this file:
 *  1. Horizon re-renders the cart drawer and cart page by morphing server
 *     HTML in on every quantity/discount change, so any state living only in
 *     the DOM is wiped. Consent is therefore mirrored into sessionStorage and
 *     re-applied whenever new cart markup appears.
 *  2. The accelerated checkout buttons (Shop Pay, PayPal, …) are third-party
 *     iframes that cannot be disabled from here — they get a transparent
 *     blocker overlay instead.
 */
(function () {
  var KEY = 'lumaro:terms-accepted';
  var accepted = false;

  try {
    accepted = sessionStorage.getItem(KEY) === '1';
  } catch (e) {
    /* private mode — fall back to per-page-load state */
  }

  function persist(value) {
    accepted = value;
    try {
      sessionStorage.setItem(KEY, value ? '1' : '0');
    } catch (e) {
      /* ignore */
    }
  }

  /** The checkout CTA block that belongs to a given consent block. */
  function ctasFor(terms) {
    var scope = terms.closest('.cart-drawer__summary, .cart__summary, cart-items-component, form, body');
    return scope ? scope.querySelector('.cart__ctas') : null;
  }

  function sync() {
    var blocks = document.querySelectorAll('[data-lux-terms]');

    for (var i = 0; i < blocks.length; i++) {
      var terms = blocks[i];
      var input = terms.querySelector('[data-lux-terms-input]');
      if (input && input.checked !== accepted) input.checked = accepted;
      terms.classList.toggle('is-accepted', accepted);
      if (accepted) {
        var hint = terms.querySelector('[data-lux-terms-hint]');
        if (hint) hint.hidden = true;
      }

      var ctas = ctasFor(terms);
      if (!ctas) continue;

      ctas.classList.toggle('is-locked', !accepted);

      var checkout = ctas.querySelector('.cart__checkout-button');
      // Never re-enable a button the theme disabled for its own reason
      // (an empty cart), so track who disabled it.
      if (checkout) {
        if (!accepted) {
          if (!checkout.disabled) checkout.dataset.luxLocked = 'true';
          checkout.disabled = true;
        } else if (checkout.dataset.luxLocked === 'true') {
          checkout.disabled = false;
          delete checkout.dataset.luxLocked;
        }
      }
    }
  }

  function reveal(terms) {
    var hint = terms.querySelector('[data-lux-terms-hint]');
    if (!hint) return;
    hint.hidden = false;
    terms.classList.remove('is-nudging');
    // restart the shake even if it is already running
    void terms.offsetWidth;
    terms.classList.add('is-nudging');
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-lux-terms-input]');
    if (!input) return;
    persist(input.checked);
    sync();
  });

  // Links inside the label would otherwise toggle the checkbox on the way out.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.lux-terms__link');
    if (link) {
      event.stopPropagation();
      return;
    }

    if (accepted) return;

    var ctas = event.target.closest && event.target.closest('.cart__ctas.is-locked');
    if (!ctas) return;

    event.preventDefault();
    var scope = ctas.closest('.cart-drawer__summary, .cart__summary, cart-items-component, form, body');
    var terms = scope && scope.querySelector('[data-lux-terms]');
    if (terms) {
      reveal(terms);
      terms.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }, true);

  // Cart markup is swapped in wholesale; re-apply state when that happens.
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      sync();
    });
  });

  function start() {
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
